<template>
  <div
    class="faq-item shadow overflow-hidden"
    :class="show ? 'bg-gray-7' : 'bg-white'"
  >
    <div
      class="question flex items-center justify-between px-6 py-4"
      @click="$emit('toggle')"
      @touchend="$emit('toggle')"
    >
      <TypeBody
        :variant="$options.Typography.Body.MEDIUM"
        :weight="$options.Typography.Weights.REGULAR"
      >
        <p class="pr-4">{{ question }}</p>
      </TypeBody>
      <BaseIcon
        icon="chevronRight"
        class="w-3 h-3 transition-all"
        :class="show ? '-rotate-90' : 'rotate-90'"
      ></BaseIcon>
    </div>
    <transition
      name="accordion"
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <client-only>
        <div
          v-show="show"
          class="answer overflow-hidden transition-all duration-300 px-8"
        >
          <TypeBody
            :variant="$options.Typography.Body.TEXT"
            :weight="$options.Typography.Weights.REGULAR"
          >
            <p class="answer-block leading-6 py-6" v-html="answer"></p>
          </TypeBody>
        </div>
      </client-only>
    </transition>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { BaseIcon, TypeBody, constants } from '@bambeehr/pollen';
const { Typography } = constants;

export default defineComponent({
  name: 'FaqItem',
  Typography,
  components: { BaseIcon, TypeBody },
  props: {
    question: {
      type: String,
      default: '',
    },
    answer: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    beforeEnter(el) {
      el.style.height = '0';
      el.style.opacity = '0';
    },
    enter(el) {
      el.style.height = el.scrollHeight + 'px';
      el.style.opacity = '1';
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + 'px';
      el.style.opacity = '1';
    },
    leave(el) {
      el.style.height = '0';
      el.style.opacity = '0';
    },
  },
});
</script>

<style scoped>
.answer-block >>> ul {
  @apply list-disc list-inside my-2;
}
.answer-block >>> ul li {
  @apply py-2;
}

.answer-block >>> ul li p {
  @apply inline;
}

.answer-block >>> ul ul {
  @apply pl-4 my-0;
}
.answer-block >>> p.subheader {
  @apply font-bold mt-4 mb-2;
}
</style>
